export default "__VITE_ASSET__D1WAYkUu__"